import { app } from '../../../../app';

app.factory('AccountPasswordUpdate', AccountPasswordUpdate);

/** @ngInject */
function AccountPasswordUpdate($resource) {
    return $resource('app/rest/accountConfig/updatePassword/', {       
    });
}



// WEBPACK FOOTER //
// ./src/portal/states/user/applications/account-password-update/account-password-update.service.js